import * as React from "react";
import { Switch, Tooltip } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { PercentageMask } from "src/util/Masks/PercentageMask";
import { PbrInputPercentage } from "src/components/common/PbrInputPercentageCalculator/PbrInputPercentage";
import { PbrInputMoney } from 'src/components/common/PbrInputMoney/PbrInputMoney';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

interface IPSSComponent {
  pssAbsoluteRequired: boolean;
  pss?: number;
  pssabsolute: number;
  isPss: boolean;
  onChangePss?: (pss: number) => void;
  onChangePssAbsolute?: (pssAbsolute: number) => void;
  onChangeIsPss?: (isPss: boolean) => void;
  canEditPssPercentual: boolean;
  canEditPssAbsolute: boolean;
  disabled?: boolean
}

export const PSSComponent = (props: IPSSComponent & FormComponentProps) => (
  <>
    <Tooltip title="PSS: Imposto de Seguridade do Servidor Público">
      <Switch
        disabled={props.disabled}
        className={"switch-input"}
        checkedChildren="Com PSS"
        unCheckedChildren="Sem PSS"
        checked={props.isPss}
        onChange={e => {
          props.onChangeIsPss(e);
        }}
      />
    </Tooltip>
    {props.isPss && !props.pssAbsoluteRequired && props.canEditPssPercentual && (
      <PbrInputPercentage
        placeholder="PSS %"
        name="pss"
        value={PercentageMask(props.pss, 2, 2)}
        formWrapper={props.form}
        rules={[{ required: true, message: "Informe Pss Percentage" }]}
        onChange={e => {
          props.onChangePss(e);
        }}
      />
    )}
    {(props.isPss) && props.pssAbsoluteRequired && props.canEditPssAbsolute && (
      <PbrInputMoney
        name="pssAbsolute"
        formWrapper={props.form}
        formItemProps={{
          label: <>PSS Absoluto<Tooltip title={"11% do principal (quando não houver principal, aplica-se 11% do juros)"}>
            <FontAwesomeIcon icon={faQuestionCircle} />
          </Tooltip></>
        }}
        placeholder="Digite o PSS Absoluto"
        value={props.pssabsolute}
        onChange={e => {
          props.onChangePssAbsolute(e);
        }}
        rules={[
          {
            required: true,
            message: "Informe o PSS equivalente a 11% do principal"
          }
        ]}
      />)}

  </>
)



// WEBPACK FOOTER //
// ./src/components/PricingComponents/PSSComponent/PSSComponent.tsx